// These are used for inserting Live Engage widget in NDX.

export const LIVE_ENGAGE_MOBILE = 'LP_DIV_RB_1502137266862';

export const LIVE_ENGAGE_DESKTOP = 'LP_DIV_RB2_34432422112';
